module.exports = __webpack_public_path__ + "img/product-22.460968fa.jpg";